import { useParams } from 'react-router-dom';
import React,{useState,useEffect} from 'react'
import { NavLink ,useLocation,useNavigate} from 'react-router-dom';
import { Col, Container, Row, Table ,Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { requestApi } from '../../../request-api';
import { directUrl } from '../../../helpers/Constants';


function CompilancerView() { 
  let [compliance,setCompliance]=useState([])
  let [complianceName,setComplianceName] = useState([])
  let {reportId,legislationId} =  useParams()
  const location = useLocation();
  let navigate = useNavigate()
  let count = 0
  console.log(reportId,legislationId)
     const getData =()=>{
         requestApi(`/compliancer/getCompliancerByLegislation/${reportId}/${legislationId}`,{
             method:'get'
         }).then((data)=>{
             console.log("first",data.data)
             setCompliance(data.data)
             let legName =[]
             data.data.map((leg)=>{
                 legName.push(leg.legislation_name)
             })
             setComplianceName(legName)
         })
 
 
 
     }
  useEffect(()=>{
   
         getData()
    
  },[])
  return (
    <main>
      <section className='lyt-section p-0'>
        <Container fluid className='typ-container'>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Breadcrumb className='bs-breadcrumb cstm-breadcrumb'>
                  <BreadcrumbItem><NavLink to={`${directUrl}compliancer/reports`}>Reports</NavLink></BreadcrumbItem>
                  <BreadcrumbItem>
                  <NavLink
              onClick={(e) => {
                e.preventDefault();
                navigate(`${directUrl}compliancer/view/legislation-list/${location.state.row.id}`, {
                  state: {
                    leg: location.state.leg,
                    row: location.state.row,
                  },
                });
              }}
            >
              {location.state.row.report_id}
            </NavLink>
                  {/* <NavLink to={`${directUrl}approver/view/legislation-list/${reportId}`}>{location.state.row.report_id}</NavLink> */}
                  </BreadcrumbItem>
                  <BreadcrumbItem>{location.state.leg.legislation_name}</BreadcrumbItem>
                  <BreadcrumbItem active>Compliance </BreadcrumbItem>
              </Breadcrumb>
              <div className='bs-table'>
                <Table responsive>
                  <thead>
                    <tr>
                      <th>Sr.No.</th>
                      <th>Compilance</th>
                      <th>Provision</th>
                      <th>Due Date</th>
                      <th>Compliance <span className='d-block'>Type</span></th>
                      <th>Status</th>
                      <th>Action</th> 
                    </tr>
                  </thead>
                  <tbody>
                      {
                        compliance.map((comp)=>{

                          count +=1;
                          return (
                            <tr>
                            <td>{count}</td>
                            <td>{comp.compliance}</td>
                            <td>{comp.provision}</td>
                            <td>{comp.due_date} </td>
                            <td>{comp.compliance_type}</td>
                            <td><span className={comp.current_compliance_status === "Complied"?'bs-status-txt typ-green bold':
                            comp.current_compliance_status == "Not Updated"?'bs-status-txt typ-red bold':
                            comp.current_compliance_status == "Not applicable"?'bs-status-txt typ-blue bold':
                            comp.current_compliance_status == "Not Complied"? 'bs-status-txt typ-red bold':
                            comp.current_compliance_status == "Complied with exception"?'bs-status-txt typ-purple bold':null
                            }>{comp.current_compliance_status}</span></td> 
                            <td><NavLink className="text-decoration-none"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(
                                `${directUrl}compliancer/view/legislation-list/${reportId}/${legislationId}/${comp.id}`,
                                { state: { leg: location.state.leg, row: location.state.row ,compliance:comp} }
                              );
                            }}
                            ><span class="icon icon-eye"></span></NavLink></td>
                          </tr>
                          )
                        })
                      }

                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    </main>
  )
}

export default CompilancerView
